export const VERSION = '10.0.13';
//# sourceMappingURL=pkg-version.js.map